import { setRoomHidden, undoRoomHidden } from '@/api/setRoomHidden'
import { useState } from 'react'
import { useMutation } from 'react-query'

const useHideRoom = ({ initialVisibility, roomId }: { initialVisibility: boolean; roomId: string }) => {
  const [isVisible, setIsVisible] = useState(initialVisibility)
  const hideRoomMutation = useMutation(setRoomHidden)
  const unHideRoomMutation = useMutation(undoRoomHidden)

  const handleHideRoom = async () => {
    setIsVisible(!isVisible)
    const action = isVisible ? hideRoomMutation : unHideRoomMutation

    try {
      await action.mutateAsync({ roomId })
    } catch (error) {
      setIsVisible(initialVisibility)
    }
  }

  return { isVisible, handleHideRoom }
}

export default useHideRoom
